import React from "react";
import { Box, LinearProgress, Stack, Typography, alpha } from "@mui/material";
import CheckCircleOutlined from "@mui/icons-material/CheckCircleOutlined";
import MovieFilterOutlined from "@mui/icons-material/MovieFilterOutlined";

const STEPS = [
  { id: "stitching", icon: MovieFilterOutlined },
  { id: "done", icon: CheckCircleOutlined },
];

/**
 * @param {{ step: 'downloading' | 'stitching' | 'done' | 'error', lang?: object, elapsedSec?: number }} props
 */
export default function StitchProgress({ step, lang, elapsedSec }) {
  const labels = {
    stitching:
      lang?.videoProjectStepStitching ||
      "Joining clips on the server… (usually under a minute for short ads)",
    done: lang?.videoProjectStepDone || "Done ✓",
    error: lang?.videoProjectStepError || "Failed",
  };

  const activeIndex = step === "done" ? 1 : step === "stitching" ? 0 : -1;

  return (
    <Stack spacing={2} sx={{ py: 1 }}>
      {STEPS.map((s, i) => {
        const Icon = s.icon;
        const isActive = step !== "error" && i === activeIndex;
        const isComplete = step === "done" ? i <= 1 : i < activeIndex;
        const color = step === "error" && i === activeIndex ? "error.main" : isComplete || isActive ? "primary.main" : "text.disabled";

        return (
          <Stack key={s.id} direction="row" spacing={1.5} alignItems="center">
            <Box
              sx={{
                width: 36,
                height: 36,
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                bgcolor: (t) =>
                  isComplete || isActive
                    ? alpha(t.palette.primary.main, 0.12)
                    : alpha(t.palette.action.disabled, 0.08),
              }}
            >
              <Icon sx={{ fontSize: 20, color }} />
            </Box>
            <Typography variant="body2" fontWeight={isActive || isComplete ? 700 : 500} color={color}>
              {labels[s.id]}
            </Typography>
          </Stack>
        );
      })}
      {step !== "done" && step !== "error" ? (
        <>
          <LinearProgress sx={{ borderRadius: 1 }} />
          <Typography variant="caption" color="text.secondary">
            {lang?.videoStitchWaitHint ||
              "Keep this window open. Large clips or 720p/1080p export can take several minutes."}
            {elapsedSec != null && elapsedSec > 0 ? ` (${elapsedSec}s)` : ""}
          </Typography>
        </>
      ) : null}
    </Stack>
  );
}
